import SubLanding from "@/components/SubLanding";
export default function MarcusAureliusAI() { return <SubLanding slug="marcus-aurelius-ai" />; }
